import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  titleEn, 
  titleFr, 
  titleAr, 
  value, 
  icon, 
  iconColor, 
  trend, 
  trendValue, 
  language, 
  navigateTo 
}) => {
  const navigate = useNavigate();

  const getTitle = () => {
    if (language === 'fr') return titleFr;
    if (language === 'ar') return titleAr;
    return titleEn;
  };

  const formatNumber = (num) => {
    if (language === 'ar') {
      return new Intl.NumberFormat('ar-MA')?.format(num);
    }
    return new Intl.NumberFormat('fr-MA')?.format(num);
  };

  const trendLabel = {
    en: trend === 'up' ? 'increase' : 'decrease',
    fr: trend === 'up' ? 'augmentation' : 'diminution',
    ar: trend === 'up' ? 'زيادة' : 'انخفاض'
  };

  const handleClick = () => {
    if (navigateTo) {
      navigate(navigateTo);
    }
  };

  return (
    <div
      className={`bg-card border border-border rounded-lg p-4 md:p-6 shadow-elevation-sm hover:shadow-elevation-md transition-all duration-250 ${
        navigateTo ? 'cursor-pointer' : ''
      }`}
      onClick={handleClick}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground mb-2">{getTitle()}</p>
          <p className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground">
            {formatNumber(value)}
          </p>
        </div>
        <div
          className={`w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-lg flex items-center justify-center ${iconColor}`}
        >
          <Icon name={icon} size={24} className="md:w-7 md:h-7 lg:w-8 lg:h-8" />
        </div>
      </div>
      {trend && trendValue && (
        <div className="flex items-center gap-2">
          <div
            className={`flex items-center gap-1 px-2 py-1 rounded ${
              trend === 'up' ?'bg-success/10 text-success' :'bg-error/10 text-error'
            }`}
          >
            <Icon
              name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'}
              size={14}
            />
            <span className="text-xs font-medium">{formatNumber(trendValue)}%</span>
          </div>
          <span className="text-xs text-muted-foreground">
            {trendLabel?.[language]}
          </span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;